// extracted by mini-css-extract-plugin
export default {"wizard":"S3+UJ","innerWizard":"MCYx+","circle":"mGH+u","isFullCircle":"Kwmcs","line":"_1gERt","isFullLine":"gsw12"};